import React from 'react';
import Checkbox from '../../../forms/Checkbox';

const EventContractShow = ({ data }) => {
    return (
        <React.Fragment>
            <div className="ckp-admin-forms-header">
                <div className="ckp-admin-grid-row">
                    <div className="ckp-admin-grid-column ckp-admin-grid-column--border-right">
                        <span className="ckp-ts-h3 u-bold u-margin-bottom-1">Event Contract Types</span>
                        <div className="ckp-admin-grid-row">
                            <Checkbox
                                className="ckp-checkbox-mui u-margin-bottom-1"
                                name="allowClearanceContracts"
                                checked
                                disabled
                                label={'Clearance Contracts'}
                            />
                        </div>
                        <div className="ckp-admin-grid-row">
                            <Checkbox
                                name="allowPerformanceContracts"
                                checked={data.allowPerformanceContracts}
                                disabled
                                label={'Performance Contracts'}
                            />
                        </div>
                    </div>
                    <div className="ckp-admin-grid-row is-wrap">
                        <div className="ckp-admin-grid-row is-100pct u-margin-bottom-3">
                            <div className="ckp-admin-grid-column u-margin-right-3">
                                <span className="ckp-ts-h3 u-bold u-margin-bottom-1">Clearance Signature</span>
                                {data.defaultSignature ? (
                                    <img
                                        className="ckp-admin-forms-show-image is-rectangle"
                                        alt="Default Signature"
                                        src={data.defaultSignature}
                                    />
                                ) : (
                                    <p className="ckp-admin-forms-show-value u-truncate">Not set</p>
                                )}
                            </div>
                            <div className="ckp-admin-grid-column">
                                <span className="ckp-ts-h3 u-bold u-margin-bottom-1">Clearance Signer</span>
                                <p className="ckp-admin-forms-show-value u-truncate">
                                    {data.defaultSigner || 'Not set'}
                                </p>
                            </div>

                            <div className="ckp-admin-grid-column">
                                <span className="ckp-ts-h3 u-bold u-margin-bottom-1">Clearance Signer Function</span>
                                <p className="ckp-admin-forms-show-value u-truncate">
                                    {data.defaultSignerFunction || 'Not set'}
                                </p>
                            </div>
                        </div>
                        {data.allowPerformanceContracts ? (
                            <div className="ckp-admin-grid-row is-100pct">
                                <div className="ckp-admin-grid-column u-margin-right-3">
                                    <span className="ckp-ts-h3 u-bold u-margin-bottom-1">Performance Signature</span>
                                    {data.performanceSignature ? (
                                        <img
                                            className="ckp-admin-forms-show-image is-rectangle"
                                            alt="Default Signature"
                                            src={data.performanceSignature}
                                        />
                                    ) : (
                                        <p className="ckp-admin-forms-show-value u-truncate">Not set</p>
                                    )}
                                </div>
                                <div className="ckp-admin-grid-column">
                                    <span className="ckp-ts-h3 u-bold u-margin-bottom-1">Performance Signer</span>
                                    <p className="ckp-admin-forms-show-value u-truncate">
                                        {data.performanceSigner || 'Not set'}
                                    </p>
                                </div>
                                <div className="ckp-admin-grid-column">
                                    <span className="ckp-ts-h3 u-bold u-margin-bottom-1">
                                        Performance Signer Function
                                    </span>
                                    <p className="ckp-admin-forms-show-value u-truncate">
                                        {data.performanceSignerFunction || 'Not set'}
                                    </p>
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default EventContractShow;
